/**
 * Outcome of attempting to take the optimistic-concurrency lease that guards
 * deposit invoice creation. Prevents concurrent webhook and staff paths from
 * both creating an invoice for the same appointment.
 */
export enum DepositInvoiceClaimStatus {
  Exists = 'exists',
  Leased = 'leased',
  Claimed = 'claimed',
}
